<template>
    <base-form v-bind="{ ...settings }" >
        <component
            :is="input"
            class="gocc__authentication__form__field"
            :settings="{
                label: { class: 'field__label--hide', text: $t('global.email') },
                input: {
                    component: 'InputBasic',
                    id: 'email',
                    name: 'email',
                    type: 'text',
                    class: 'gocc__authentication__form__field__input',
                    value: '',
                    placeholder: $t('global.email'),
                    isRequired: true,
                    fileValidation: 'basicEmail',
                    errors: [{
                        type: 'email', warning: $t('error.email')
                    }],
                    isMissing: '',
                    noListener: true
                },
                allowFilling: true
            }"
        />
        <div class="gocc__authentication__form__field--margin">
            <submission-handler>
                <component
                    :is="button"
                    type="submit"
                    class="gocc__authentication__form__button background--green color--white"
                    v-html="$t('global.ask')"
                />
            </submission-handler>
        </div>
        <router-link
            to="/authentication/login"
            activeClass="active"
            class="gocc__authentication__form__anchor gocc__authentication__form__back display--block color--green capitalize"
        >
            {{ $t('authentication.back') }}
        </router-link>
    </base-form>
</template>

<script>
// hooks
import { authenticationStructure } from '@/hooks/use-data';

export default {
    ...authenticationStructure
};
</script>